import type { Work, WorkType } from "@/mocks/works";
import { works } from "@/mocks/works";
import type { NewsArticle } from "@/mocks/news";
import { newsList } from "@/mocks/news";

export const allWorks: Work[] = works;
export const allNews: NewsArticle[] = newsList;

export const getWorkById = (id?: string): Work | undefined => allWorks.find((w) => w.id === id);

export const getNewsById = (id?: string): NewsArticle | undefined => allNews.find((n) => n.id === id);

export const worksByType = (type?: WorkType | "all"): Work[] =>
  type && type !== "all" ? allWorks.filter((w) => w.type === type) : allWorks;

export const latestWorks = (limit = 8): Work[] =>
  [...allWorks].sort((a, b) => b.year - a.year || b.views - a.views).slice(0, limit);

export const popularWorks = (limit = 5): Work[] =>
  [...allWorks].sort((a, b) => b.views - a.views).slice(0, limit);

export const relatedWorks = (work: Work, limit = 4): Work[] =>
  allWorks
    .filter((w) => w.id !== work.id)
    .sort((a, b) => {
      const scoreA = a.genres.filter((g) => work.genres.includes(g)).length + (a.type === work.type ? 1 : 0);
      const scoreB = b.genres.filter((g) => work.genres.includes(g)).length + (b.type === work.type ? 1 : 0);
      return scoreB - scoreA || b.views - a.views;
    })
    .slice(0, limit);

export const newsByWork = (workId: string): NewsArticle[] =>
  allNews.filter((n) => n.relatedWorkId === workId);

export const relatedNews = (article: NewsArticle, limit = 3): NewsArticle[] =>
  allNews
    .filter((n) => n.id !== article.id)
    .sort((a, b) => {
      const scoreA = (a.tag === article.tag ? 2 : 0) + (a.relatedWorkId === article.relatedWorkId ? 2 : 0);
      const scoreB = (b.tag === article.tag ? 2 : 0) + (b.relatedWorkId === article.relatedWorkId ? 2 : 0);
      return scoreB - scoreA || b.date.localeCompare(a.date);
    })
    .slice(0, limit);

export const searchAll = (keyword: string): { works: Work[]; news: NewsArticle[] } => {
  const key = keyword.trim().toLowerCase();
  if (!key) return { works: [], news: [] };
  return {
    works: allWorks.filter(
      (w) =>
        w.title.toLowerCase().includes(key) ||
        w.genres.some((g) => g.includes(key)) ||
        w.cast.some((c) => c.includes(key)) ||
        w.director.includes(key) ||
        w.tags.some((t) => t.includes(key)),
    ),
    news: allNews.filter(
      (n) => n.title.toLowerCase().includes(key) || n.summary.toLowerCase().includes(key) || n.tag.includes(key),
    ),
  };
};

export const workFormat = (type: WorkType): string => (type === "movie" ? "电影" : "电视剧");

export const formatViews = (views: number): string => {
  if (views >= 10000) return `${(views / 10000).toFixed(1)} 万`;
  return String(views);
};